import styled from "styled-components"

export const StyledOverview = styled.div`
  height: calc(100% - var(--fit-banner-height));
  background: #00263a;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  color: #fff;
`

export const StyledDay = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const OverviewMain = styled.div`
  overflow-y: auto;
  flex: 1;
  width: 100%;
  position: relative;

  svg,
  g,
  path {
    &:focus,
    &:active {
      outline: none;
    }
  }

  .recharts-cartesian-axis-line {
    stroke: rgba(255, 255, 255, 0.1);
  }

  .recharts-surface {
    overflow: visible;
  }

  .recharts-yAxis .recharts-label {
    transform: translateX(0px);
    font-size: 10px;
    font-weight: 600;
    fill: rgba(255, 255, 255, 0.8);
    color: rgba(255, 255, 255, 0.8);

    tspan {
      font-weight: 600;
    }
  }

  .recharts-cartesian-grid-horizontal {
    line {
      &:first-child {
        display: none;
      }
    }
  }
`

export const OverviewBgOverlay = styled.div<{ $height: number }>`
  background: linear-gradient(180deg, #05050c 0%, rgba(5, 5, 12, 0) 100%);
  height: ${(props) => props.$height}px;
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  z-index: 0;
  pointer-events: none;
`

export const OverviewHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 16px;
  width: 100%;
  z-index: 1;
`

export const FullLoading = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const OverviewContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`

export const ChartSection = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px;
`

export const TimeController = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  width: 100%;
`

export const PeriodButton = styled.div`
  display: flex;
  flex: 1;
  gap: 4px;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
`

export const TodayButton = styled.div<{ $disabled?: boolean }>`
  display: flex;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
  color: ${(props) => (props.$disabled ? "rgba(255, 255, 255, 0.2)" : "#fff")};
  pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
`

export const NavButton = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
`

export const MealTypeBreakdownSection = styled.div`
  padding: 0 24px;
`

export const WaterTabContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`

export const NoDataText = styled.div`
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  line-height: 1.6;
  width: 237px;
  margin: 0 auto;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const WaterBottomSheet = styled.div`
  background: #0d3144;
  border-radius: 32px 32px 0 0;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 24px 12px;
  display: flex;
  flex-direction: column;
`
